/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Banks } from './Banks';
import type { Clearing } from './Clearing';
import type { FinancierLedger } from './FinancierLedger';
import type { MiddleMan } from './MiddleMan';
import type { MOTAL } from './MOTAL';
import type { Revenue } from './Revenue';
import type { Shop } from './Shop';
import type { THB } from './THB';
import type { ThirdParty } from './ThirdParty';
import type { USD } from './USD';
export type StatementEntry = {
    tx: string;
    subTx: string;
    from: (Banks | Clearing | FinancierLedger | MiddleMan | Revenue | Shop | ThirdParty);
    fromName?: string;
    to: (Banks | Clearing | FinancierLedger | MiddleMan | Revenue | Shop | ThirdParty);
    toName?: string;
    amount: number;
    currency: (MOTAL | THB | USD);
    type: StatementEntry.type;
    feature: StatementEntry.feature;
    createdAt: string;
    ledgerSource: StatementEntry.ledgerSource;
    ledgerSourceId?: string;
    ledgerSourceName?: string;
    status: StatementEntry.status;
    parentTx?: string;
    metadata?: Record<string, Record<string, any>>;
    channel: StatementEntry.channel;
};
export namespace StatementEntry {
    export enum type {
        SERVICE_CONSUMPTION = 'SERVICE_CONSUMPTION',
        CURRENCY_CONVERSION = 'CURRENCY_CONVERSION',
        THIRD_PARTY_API_CALL = 'THIRD_PARTY_API_CALL',
        TOP_UP = 'TOP_UP',
        INCREASE_CREDIT = 'INCREASE_CREDIT',
        DECREASE_CREDIT = 'DECREASE_CREDIT',
        REFUND = 'REFUND',
        MIDDLEMAN_FEE = 'MIDDLEMAN_FEE',
        COMMISSION_WITHDRAWAL = 'COMMISSION_WITHDRAWAL',
        PROFIT = 'PROFIT',
    }
    export enum feature {
        SHOP_CREDIT = 'SHOP_CREDIT',
        CHECK_IMEI = 'CHECK_IMEI',
        CHECK_SLIP = 'CHECK_SLIP',
        OTHER = 'OTHER',
    }
    export enum ledgerSource {
        ADMIN = 'ADMIN',
        SHOP = 'SHOP',
        USER = 'USER',
        QR_PAYMENT = 'QR_PAYMENT',
    }
    export enum status {
        SUCCESS = 'SUCCESS',
        FAILED = 'FAILED',
        PENDING = 'PENDING',
    }
    export enum channel {
        WEB = 'WEB',
        LINE = 'LINE',
    }
}

